const tabs = [
  "Overview",
  "Contributions",
  "NAV & Performance",
  "Statements",
  "Analytics",
  "Withdrawal",
];

const NpsTabs: React.FC<{
  activeTab: string;
  onChange: (tab: string) => void;
}> = ({ activeTab, onChange }) => {
  return (
    <div className="mt-4 w-full overflow-x-auto rounded-xl border border-gray-200 bg-gray-50">
      <div className="flex whitespace-nowrap">
        {tabs.map(tab => {
          const isActive = activeTab === tab;

          return (
            <button
              key={tab}
              onClick={() => onChange(tab)}
              className={`flex-1 px-6 py-3 text-sm font-medium transition-all ${
                isActive
                  ? "rounded-xl bg-white text-teal-700 shadow-sm"
                  : "text-gray-600 hover:text-teal-600"
              }`}
            >
              {tab}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default NpsTabs;
